import Slider from "react-slick";
import { FileItem } from "../../models/types/common";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { MediaUrl } from "../../utils/configuration";
import SlickArrowLeft from "./arr-left";
import SlickArrowRight from "./arr-right";
import PopupCarousel from "./popupCarousel";
import { useState } from "react";
export interface CarouselProps {
  files: FileItem[];
}

const Carousel = ({ files }: CarouselProps) => {
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const [initIndex, setInitIndex] = useState<number>(0);
  const handleOpenPopup = (index: number) => {
    setInitIndex(index);
    setOpenPopup(true);
  };
  const handleClosePopup = () => {
    setOpenPopup(false);
  };
  if (!files || files.length === 0) {
    return (
      <Box textAlign="center">
        <Typography color="text.secondary">Không có ảnh</Typography>
      </Box>
    );
  }

  const settings = {
    customPaging: function (i: number) {
      return (
        <a>
          <img src={`${MediaUrl}${files[i].path}`} alt={files[i].fileName} />
        </a>
      );
    },
    dots: true,
    dotsClass: "slick-dots custom-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SlickArrowRight className="slider-arr-right" />,
    prevArrow: <SlickArrowLeft className="slider-arr-left" />,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    gap: 10,
    centerMode: true,
    centerPadding: "100px",
    className: "center",
    responsive: [

      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "100px",
          infinite: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          infinite: true,
        },
      },
    ],
  };

  return (
    <div>
      <Slider {...settings}>
        {files.map((file, index) => (
          <Box key={file.id} display="flex" justifyContent="center" alignItems="center" height={300}>
            <img
              src={MediaUrl + file.path}
              alt={file.fileName}
              className="w-full h-full cursor-pointer object-cover p-2"
              onClick={() => handleOpenPopup(index)}
            />
          </Box>
        ))}
      </Slider>
      <PopupCarousel files={files} isOpen={openPopup} onClose={handleClosePopup} initIndex={initIndex} />
    </div>
  );
};

export default Carousel;